
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'CrmMobilePullRefreshIndicator',
  props: {
    heightPx: {
      type: Number,
      default: 0,
    },
    armed: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const visible = computed(() => props.heightPx >= 12)
    const progressPct = computed(() => {
      const cap = 96
      return Math.min(100, Math.round((props.heightPx / cap) * 100))
    })
    return { visible, progressPct }
  },
})
